import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function findSeaImportJobByNo(data) {
  return request({
    url: URL.seaImport.findSeaImportJobByNo,
    method: 'post',
    data
  })
}

export function findNoJoinSeaImportJob(params) {
  return request({
    url: URL.seaImport.findNoJoinSeaImportJob,
    method: 'get',
    params
  })
}

export function advancedQuery(data) {
  return request({
    url: URL.seaImport.advancedQuery,
    method: 'post',
    data
  })
}

export function findSeaImportLCLMoreJob(data) {
  return request({
    url: URL.seaImport.findSeaImportLCLMoreJob,
    method: 'post',
    data
  })
}

export function queryLastModifyBookingByDay(data) {
  return request({
    url: URL.seaImport.queryLastModifyBookingByDay,
    method: 'post',
    data
  })
}

// 加载海出Job的关联实体信息
export function loadseaImportJobRelated(data) {
  return request({
    url: URL.seaImport.loadSeaImportJobRelated,
    method: 'post',
    data: data
  })
}

export function saveSeaBookingSpace(data, fullError, forbidAlert) {
  return request({
    url: URL.seaImport.saveSeaBookingSpace,
    method: 'post',
    fullError,
    forbidAlert,
    data
  })
}

export function syncContainersToExport(data) {
  return request({
    url: URL.seaImport.syncContainersToExport,
    method: 'post',
    data
  })
}

export function queryCustomerRemarksHistory() {
  return request({
    url: URL.seaImport.queryCustomerRemarksHistory,
    method: 'get'
  })
}

export function findSeaImportExcerption(params) {
  return request({
    url: URL.seaImport.findSeaImportExcerption,
    method: 'get',
    params
  })
}

// 同步仓库
export function syncLclSlaveJobInfo(data) {
  return request({
    url: URL.seaImport.syncLclSlaveJobInfo,
    method: 'post',
    data
  })
}

// 主票加入小票-查询
export function getSeaImportJobsByLclMasterJobFunc(data) {
  return request({
    url: URL.seaImport.getSeaImportJobsByLclMasterJobUrl,
    method: 'post',
    data
  })
}

// 向主票中批量加入业务
export function batchAddJob(data, lclMasterUuid, location) {
  return request({
    url: URL.seaImport.batchAddJob,
    method: 'post',
    data,
    params: { lclMasterUuid, location }
  })
}

export function getChargeList(jobUuid) {
  return request({
    url: URL.seaImport.getChargeList,
    method: 'post',
    data: { 'jobUuid': jobUuid }
  })
}

export function batchEditCharge(requestBody) {
  return request({
    url: URL.seaImport.batchEditCharge,
    method: 'post',
    data: requestBody
  })
}

export function shutOut(data) {
  return request({
    url: URL.seaImport.shutOut,
    method: 'post',
    data
  })
}

export function getChargeIsInvoice(jobUuid) {
  return request({
    url: URL.seaImport.getChargeIsInvoice,
    method: 'get',
    params: { jobUuid }
  })
}

export function getLclSlaves(jobUuid) {
  return request({
    // url: URL.seaImport.getLclSlaves,
    url: URL.seaImport.getseaImportLclSlaves, // 返回 seaImportJob 结构对象
    method: 'get',
    params: { jobUuid }
  })
}

export function commit(jobUuid, operateNameCode, isPreCommit, officeId) {
  return request({
    url: URL.seaImport.commit,
    method: 'get',
    params: { jobUuid, operateNameCode, isPreCommit, officeId }
  })
}

export function calculateProfit(jobUuid, operateNameCode, isPrintOpr, allSubmitFcl, isPreCommit, officeId) {
  return request({
    url: URL.seaImport.calculateProfit,
    method: 'get',
    params: { jobUuid, operateNameCode, isPrintOpr, allSubmitFcl, isPreCommit, officeId }
  })
}

export function printProfit(jobUuid, operateNameCode, officeId) {
  return request({
    url: URL.seaImport.printProfit,
    method: 'get',
    params: { jobUuid, operateNameCode, officeId }
  })
}

export function prePrintProfit(jobUuid, officeId) {
  return request({
    url: URL.seaImport.prePrintProfit,
    method: 'get',
    params: { jobUuid, officeId }
  })
}

export function saveJobInfo(data) {
  return request({
    url: URL.seaImport.saveJobInfo,
    method: 'post',
    data
  })
}

export function feedbackBookingData(data) {
  return request({
    url: URL.seaImport.feedbackBookingData,
    method: 'post',
    data
  })
}

export function getCargoDoc(params) {
  return request({
    url: URL.seaImport.getCargoDoc,
    method: 'get',
    params
  })
}

export function updateSeaJobsFromReceipt(params) {
  return request({
    url: URL.seaImport.updateSeaJobsFromReceipt,
    method: 'post',
    params
  })
}

export function loadJobParams(data) {
  return request({
    url: URL.seaImport.loadJobParams,
    method: 'post',
    data
  })
}

export function getJob(jobNo, crossTenantId) {
  return request({
    url: URL.seaImport.getJob,
    method: 'get',
    params: { jobNo, crossTenantId }
  })
}

export function getRelatedJob(jobNo) {
  return request({
    url: URL.seaImport.getRelatedJob,
    method: 'get',
    params: { jobNo }
  })
}

export function checkingConsignationJob(jobUuid) {
  return request({
    url: URL.seaImport.checkingConsignationJob,
    method: 'get',
    params: { jobUuid }
  })
}

export function saveCloneJob(data) {
  return request({
    url: URL.seaImport.saveCloneJob,
    method: 'post',
    data
  })
}

export function crossTenantJob(data) {
  return request({
    url: URL.seaImport.crossTenantJob,
    method: 'post',
    data
  })
}

export function queryJobStateUpdateLog(jobUuid) {
  return request({
    url: URL.seaImport.queryJobStateUpdateLog,
    method: 'get',
    params: { jobUuid }
  })
}

export function queryBusinessAdjustmentLog(jobUuid) {
  return request({
    url: URL.seaImport.queryBusinessAdjustmentLog,
    method: 'get',
    params: { jobUuid }
  })
}

export function ediUpdateLog(jobUuid) {
  return request({
    url: URL.seaImport.ediUpdateLog,
    method: 'get',
    params: { jobUuid }
  })
}

export function queryMessageLog(jobUuid) {
  return request({
    url: URL.seaImport.queryMessageLog,
    method: 'get',
    params: { jobUuid }
  })
}

export function doCopyJob(data) {
  return request({
    url: URL.seaImport.doCopyJob,
    method: 'post',
    data
  })
}

// 批量复制小票，组装数据返回给前台
export function batchCloneLcLJob(params) {
  return request({
    url: URL.seaImport.batchCloneLcLJob,
    method: 'get',
    params
  })
}

export function isContractExpiredForbidCreateJob(cmpIdx) {
  return request({
    url: URL.seaImport.isContractExpiredForbidCreateJob,
    method: 'get',
    params: { cmpIdx }
  })
}

export function saveCopyJob(data) {
  return request({
    url: URL.seaImport.saveCopyJob,
    method: 'post',
    data
  })
}

// 加载edi回执状态
export function queryEDIFeedBackState(params) {
  return request({
    url: URL.seaImport.queryEDIFeedBackState,
    method: 'get',
    params
  })
}

export function splitMaster(data) {
  return request({
    url: URL.seaImport.splitMaster,
    method: 'post',
    data
  })
}

export function getseaImportLclSlaves(jobUuid) {
  return request({
    url: URL.seaImport.getseaImportLclSlaves,
    method: 'get',
    params: { jobUuid }
  })
}

export function shareCharges(data) {
  return request({
    url: URL.seaImport.shareCharges,
    method: 'put',
    data
  })
}

// 移除并单操作
export function unJointSlavesHblOrMbl(data) {
  return request({
    url: URL.seaImport.unJointSlavesHblOrMbl,
    method: 'post',
    data
  })
}

// 获取业务的sop信息
export function getJobSopStates(data) {
  return request({
    url: URL.seaImport.getJobSopStates,
    method: 'post',
    data
  })
}

// 预报
export function findSeaImportPerNoJob(data) {
  return request({
    url: URL.seaImport.findSeaImportPerNoJobOfPrediction,
    method: 'post',
    data
  })
}

// 预报-查询最近两个工作日编辑过的单子
export function findPredictTwoWorkJob(data) {
  return request({
    url: URL.seaImport.findPredictTwoWorkJob,
    method: 'post',
    data
  })
}

export function doCopyJobOfPrediction(data) {
  return request({
    url: URL.seaImport.doCopyJobOfPrediction,
    method: 'post',
    data
  })
}

export function deleteJobOfPrediction(uuid) {
  return request({
    url: URL.seaImport.deleteJobOfPrediction + '?jobUuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 预报-批量删除
export function batchDeleteJobOfPredictionHandler(data) {
  return request({
    url: URL.seaImport.batchDeleteJobOfPredictionUrl,
    method: 'post',
    data
  })
}

export function preVerifyReject(data) {
  return request({
    url: URL.seaImport.preVerifyReject,
    method: 'put',
    params: data
  })
}

export function regularBusiness(data) {
  return request({
    url: URL.seaImport.regularBusiness,
    method: 'put',
    data
  })
}

export function getSeaImportJobByUuid(uuid) {
  return request({
    url: URL.seaImport.getSeaImportJobByUuid,
    method: 'get',
    params: { uuid }
  })
}
// 仓库操作-列表查询
export function queryWareHouse(data) {
  return request({
    url: URL.seaImport.queryWareHouse,
    method: 'post',
    data
  })
}
// 仓库操作-入库出库
export function saveInOrOutWareHouse(data, lob, isIn) {
  return request({
    url: URL.seaImport.saveInOrOutWareHouse,
    method: 'post',
    data: data,
    params: { lob, isIn }
  })
}

// 同步信息-跨租户进口同步到出口
export function syncTrustFromJob(jobKey) {
  return request({
    url: URL.seaImport.syncTrustFromJob,
    method: 'get',
    params: { jobKey }
  })
}

export function loadLclJobSeaCargoDocList(data) {
  return request({
    url: URL.seaImport.loadLclJobSeaCargoDocList,
    method: 'post',
    data
  })
}

export function batchTransship(requestBody) {
  return request({
    url: URL.seaImport.batchTransship,
    method: 'post',
    data: requestBody
  })
}

export function saveCloneJobFunc(data) {
  return request({
    url: URL.seaImport.saveCloneJobUrl,
    method: 'post',
    data
  })
}

export function getRelatedJobFunc(jobNo) {
  return request({
    url: URL.seaImport.getRelatedJobUrl,
    method: 'get',
    params: { jobNo }
  })
}
